(function () {
  function removeRxVariants() {
    document.querySelectorAll('.restock-alerts-variant-select option').forEach(option => {
      if (option.textContent.includes('RX')) {
        option.remove();
      }
    });
  }

  // Check iniziale
  removeRxVariants();

  // Notify Me carica il popup dinamicamente
  const observer = new MutationObserver(() => {
    removeRxVariants();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();